// material-ui
import { styled } from '@mui/material/styles';

// ==============================|| AUTHENTICATION 1 WRAPPER ||============================== //

const AuthWrapper1 = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.light,
  minHeight: '100vh',
  paddingTop: 'var(--safe-area-top)',
  paddingRight: 'var(--safe-area-right)',
  paddingBottom: 'var(--safe-area-bottom)',
  paddingLeft: 'var(--safe-area-left)'
}));

export default AuthWrapper1;
